import { Injectable, model } from '@angular/core';
import { SharedService } from './shared.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { API_URL } from '../shared/config';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { NotifyDialogService } from './notify-dialog.service';
import { BoxMetrics } from '../interfaces/BoxMetrix';
import { ServerResponse, ServerResponseObject } from '../interfaces/ServerResponse';
import { Record } from '../interfaces/Record';
import { DatabaseIcon, DatabaseShape } from '../interfaces/DatabaseVisual';
import { AllMetricsTypes, MetricType } from '../interfaces/MetricType';
import { CustomerDocument } from '../interfaces/CustomerDocument';
import { NumOfDocs } from '../interfaces/NumOfDocs';
import { GraphItem } from '../interfaces/GraphItem';
import { HeaderValues } from '../interfaces/HeaderValues';
import { DataServiceModel } from '../interfaces/Model';
import { DataService } from '../interfaces/DataService';
import { ViewsTree } from '../interfaces/ViewsTree';
import { HyperFlowsCategory } from '../interfaces/HyperFlows';
import { HeatMap } from '../interfaces/HeatMap';
import { ISchemaTree } from '../interfaces/SchemaTree';
import {
  SchemaPermissionAssignment,
  SchemaPermissionNode,
  UserSchemaPermission
} from '../interfaces/SchemaPermission';

@Injectable({
  providedIn: 'root'
})
export class BeNeo4jService {

  API_URL = environment.API_URL;

  constructor(private http: HttpClient, public shared: SharedService, private notifyDialogService: NotifyDialogService) { }

  hierarchies(){
    let url = `${this.API_URL}/hiers/list`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection
    }});
    return this.http.get(url, {
      params
    })
  }

  hierarchy(){
    let url = `${this.API_URL}/hiers/level_structure`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection
    }});
    return this.http.get(url, {
      params
    })
  }

  getHyperFlows(){
    let url = `${this.API_URL}/hiers/hier/hyper_flows`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection
    }});
    return this.http.get(url, {
      params
    })
  }

  schemaTree(edt_uuid: string = "", hierarchy_name: string = ""){
    let url = `${this.API_URL}/hiers/hier/obj_schema_main_tree`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      edt_uuid,
      hierarchy_name
    }});
    return this.http.get<ServerResponse<ISchemaTree>>(url, {
      params
    })
  }

  getCypherById(node_id: string, hierarchy_name: string, include_father: boolean = true, connectionString?: string){
    let url = `${this.API_URL}/hiers/hier/obj_node_children_and_schema_nodes`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ?? this.shared.data_service!.string_connection,
      hierarchy_name,
      node_id,
      include_father
    }});
    return this.http.get(url, {
      params
    })
  }

  getNodeCypherById(node_id: string, label: string){
    let url = `${this.API_URL}/hiers/hier/obj_node`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      node_id,
      label
    }});
    return this.http.get(url, {
      params
    })
  }

  getOnlyChildrenCypherById(node_id: string, hierarchy_name: string){
    let url = `${this.API_URL}/hiers/hier/obj_node_children`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      node_id,
      hierarchy_name
    }});
    return this.http.get(url, {
      params
    })
  }

  getRelationships(){
    let url = `${this.API_URL}/neo4jdb/relationships`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection
    }});
    return this.http.get(url, {
      params
    })
  }

  getLabels(){
    let url = `${this.API_URL}/neo4jdb/labels`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection
    }});
    return this.http.get(url, {
      params
    })
  }


  getIcons(): Observable<ServerResponse<DatabaseIcon>>{
    let url = `${this.API_URL}/neo4jdb/label_objects`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      label_name: 'Icon'
    }});
    return this.http.get<ServerResponse<DatabaseIcon>>(url, {
      params
    })
  }

  getShapes(): Observable<ServerResponse<DatabaseShape>>{
    let url = `${this.API_URL}/neo4jdb/label_objects`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      label_name: 'Shape'
    }});
    return this.http.get<ServerResponse<DatabaseShape>>(url, {
      params
    })
  }

  Execute(cypher: string, connectionString?: string): Observable<ServerResponse<Record>>{
    let url = `${this.API_URL}/neo4jdb/execute`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ? connectionString : this.shared.data_service!.string_connection,
      cypher_script: cypher
    }});
    return this.http.get<ServerResponse<Record>>(url, {
      params
    })
  }

  Metrics(year: number, month: number, day: number, model_uuid: string, metric: string, connectionString?: string): Observable<ServerResponse<BoxMetrics>>{
    let url = `${this.API_URL}/metrics/getting_values`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ? connectionString : this.shared.data_service!.string_connection,
      year,
      month,
      day,
      model_uuid,
      metric
    }});
    return this.http.get<ServerResponse<BoxMetrics>>(url, {
      params
    })
  }

   MetricsTypes(hierarchy: string, connectionString?: string): Observable<ServerResponseObject<AllMetricsTypes>>{
    let url = `${this.API_URL}/metrics/list_metrics_hierarchy`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ? connectionString : this.shared.data_service!.string_connection,
      hierarchy
    }});
    return this.http.get<ServerResponseObject<AllMetricsTypes>>(url, {
      params
    })
  }

  GetDocumentsByReference(hierarchy: string, model_uuid: string, reference_id: string, connectionString?: string): Observable<ServerResponse<CustomerDocument>>{
    let url = `${this.API_URL}/metrics/getting_log_reference_id`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ? connectionString : this.shared.data_service!.string_connection,
      hierarchy,
      reference_id,
      model_uuid,
    }});
    return this.http.get<ServerResponse<CustomerDocument>>(url, {
      params
    })
  }

  GetDocument(log_UUID: string, datetime_limit: string, metric: string, connectionString?: string): Observable<ServerResponse<BoxMetrics>>{
    let url = `${this.API_URL}/metrics/getting_values_for_specific_log`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ? connectionString : this.shared.data_service!.string_connection,
      log_UUID,
      datetime_limit,
      metric,
    }});
    return this.http.get<ServerResponse<BoxMetrics>>(url, {
      params
    })
  }

  getWorstCases(
      year: number,
      month: number,
      day: number,
      hierarchy: string,
      model_uuid: string,
      metric: string,
      page: number,
      records: number,
      get_size: boolean,
      connectionString?: string
    ): Observable<ServerResponse<CustomerDocument | NumOfDocs>>{
    let url = `${this.API_URL}/metrics/getting_log_worse_cases`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ? connectionString : this.shared.data_service!.string_connection,
      year,
      month,
      day,
      hierarchy,
      metric,
      model_uuid,
      page,
      records,
      get_size
    }});
    return this.http.get<ServerResponse<CustomerDocument | NumOfDocs>>(url, {
      params
    })
  }

  getGraph(
      year: number,
      month: number,
      day: number,
      hierarchy: string,
      model_uuid: string,
      metric: string,
      connectionString?: string
    ): Observable<ServerResponse<GraphItem>>{
    let url = `${this.API_URL}/metrics/getting_values_for_graph`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ? connectionString : this.shared.data_service!.string_connection,
      year,
      month,
      day,
      hierarchy,
      metric,
      model_uuid,
    }});
    return this.http.get<ServerResponse<GraphItem>>(url, {
      params
    })
  }

  getHeaderValues(
      year: number,
      month: number,
      day: number,
      hierarchy: string,
      model_uuid: string,
      metric: string,
      connectionString?: string
    ): Observable<ServerResponse<HeaderValues[]>>{
    let url = `${this.API_URL}/metrics/getting_values_for_header`;
    const params = new HttpParams({ fromObject: {
      string_connection: connectionString ? connectionString : this.shared.data_service!.string_connection,
      year,
      month,
      day,
      hierarchy,
      metric,
      model_uuid,
    }});
    return this.http.get<ServerResponse<HeaderValues[]>>(url, {
      params
    })
  }

  exportTaxonomyByHierarcht(hierarchy_name: string){
    let url = `${this.API_URL}/hiers/hier/export`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      hierarchy_name,
    }});
    return this.http.get<ServerResponse<any>>(url, {
      params
    })
  }

  importDataInDatabase(subclass_father_uuid: string, file_struct: any[]){
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/hiers/hier/import`;
    return this.http.post<ServerResponse<any>>(url, {
      string_connection: this.shared.data_service.string_connection,
      subclass_father_uuid,
      file_struct,
  //     "create_new_hierarchy_name": "new hier",
  // "create_new_UUID": false,
    })
  }

  exportHyperflows(hierarchy_name: string){
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/hiers/hier/export_hyperflows`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      hierarchy_name,
    }});
    return this.http.get<ServerResponse<any>>(url, {
      params
    })
  }

  getSchemas(
      page: number,
      records: number,
      search_text: string|null,
    ): Observable<ServerResponse<DataServiceModel>>{
    let url = `${this.API_URL}/hiers/hier/ds_model`;
    return this.http.post<ServerResponse<DataServiceModel>>(url, {
      string_connection: this.shared.data_services?.map((ds: DataService)=>ds.string_connection),
      search_text,
      page,
      records
    });
  }

  getUsersSchemaPermissions(user_id: string, string_connection?: string): Observable<ServerResponse<UserSchemaPermission>> {
    const url = `${this.API_URL}/hiers/get_users_schema_permissions`;
    let params = new HttpParams({ fromObject: {
      string_connection: string_connection ? string_connection : this.shared.data_service!.string_connection,
      user_id
    }});
    return this.http.get<ServerResponse<UserSchemaPermission>>(url, { params });
  }

  getSchemasManagerPermissions(string_connection?: string): Observable<ServerResponse<SchemaPermissionNode>> {
    const url = `${this.API_URL}/hiers/get_schemas_manager_permissions`;
    const params = new HttpParams({ fromObject: {
      string_connection: string_connection ? string_connection : this.shared.data_service!.string_connection
    }});
    return this.http.get<ServerResponse<SchemaPermissionNode>>(url, { params });
  }

  setSchemasPermissions(
    string_connection: string,
    label_node: string,
    uuid_node: string,
    permissions: SchemaPermissionAssignment[]
  ): Observable<ServerResponse<unknown>> {
    const url = `${this.API_URL}/hiers/schemas_permissions`;
    const params = new HttpParams({ fromObject: {
      string_connection,
      label_node,
      uuid_node
    }});
    return this.http.post<ServerResponse<unknown>>(url, permissions, { params });
  }

  getViewsStruct(string_connection?: string): Observable<ServerResponse<ViewsTree>>{
    let url = `${this.API_URL}/view_struct/viewStructure`;
    const params = new HttpParams({ fromObject: {
      string_connection: string_connection ? string_connection : this.shared.data_service!.string_connection
    }});
    return this.http.get<ServerResponse<ViewsTree>>(url, {params});
  }

  addNestedNodeViewTree(level_name: string, string_connection?: string, father_UUID: string = ""): Observable<ServerResponse<ViewsTree>>{
    let url = `${this.API_URL}/view_struct/add_nested_nodeviewtree`;
    const params = new HttpParams({ fromObject: {
      string_connection: string_connection ? string_connection : this.shared.data_service!.string_connection,
      level_name,
      father_UUID
    }});
    return this.http.get<ServerResponse<any>>(url, {params});
  }

  updateNestedNodeViewTree(level_name: string, level_UUID: string, string_connection?: string): Observable<ServerResponse<ViewsTree>>{
    let url = `${this.API_URL}/view_struct/update_nested_nodeviewtree`;
    const params = new HttpParams({ fromObject: {
      string_connection: string_connection ? string_connection : this.shared.data_service!.string_connection,
      level_name,
      level_UUID
    }});
    return this.http.get<ServerResponse<any>>(url, {params});
  }

  removeNestedNodeViewTree(level_UUID: string, string_connection?: string): Observable<ServerResponse<ViewsTree>>{
    let url = `${this.API_URL}/view_struct/remove_nested_nodeviewtree`;
    const params = new HttpParams({ fromObject: {
      string_connection: string_connection ? string_connection : this.shared.data_service!.string_connection,
      level_UUID
    }});
    return this.http.get<ServerResponse<any>>(url, {params});
  }

  linkView_ViewStructure(level_UUID: string, view_UUID: string, string_connection?: string): Observable<ServerResponse<ViewsTree>>{
    let url = `${this.API_URL}/view_struct/link_view_viewstructure`;
    const params = new HttpParams({ fromObject: {
      string_connection: string_connection ? string_connection : this.shared.data_service!.string_connection,
      level_UUID,
      view_UUID
    }});
    return this.http.get<ServerResponse<any>>(url, {params});
  }

  removeLinkView_ViewStructure(level_UUID: string, view_UUID: string, string_connection?: string): Observable<ServerResponse<ViewsTree>>{
    let url = `${this.API_URL}/view_struct/remove_link_view_viewstructure`;
    const params = new HttpParams({ fromObject: {
      string_connection: string_connection ? string_connection : this.shared.data_service!.string_connection,
      level_UUID,
      view_UUID
    }});
    return this.http.get<ServerResponse<any>>(url, {params});
  }

  getNodeHyperFlows(hierarchy_name: string, node_UUID: string, label_UUID: string): Observable<ServerResponse<HyperFlowsCategory>>{
    let url = `${this.API_URL}/hiers/hier/node_hyperflows`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      hierarchy_name,
      node_UUID,
      label_UUID
    }});
    return this.http.get<ServerResponse<HyperFlowsCategory>>(url, {params});
  }

  getValuesBottleneck(
    year: number,
    month: number,
    day: number,
    hierarchy: string,
    model_uuid: string,
  ): Observable<ServerResponse<HeatMap>>{
    let url = `${this.API_URL}/metrics/getting_values_for_bottleneck`;
    const params = new HttpParams({ fromObject: {
      string_connection: this.shared.data_service!.string_connection,
      year,
      month,
      day,
      hierarchy,
      model_uuid,
    }});
    return this.http.get<ServerResponse<HeatMap>>(url, {params});
  }

}
